import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

import { WS_EVENTS } from '../lib/websocket/events';
import { useWebSocket } from '../lib/websocket/WebSocketProvider';

/**
 * Subscribe global em `integrations.feature-toggled` para invalidar
 * `customer-context` quando admin pausa/reativa a feature em qualquer aba
 * do navegador (ou outro user admin no mesmo tenant).
 *
 * Pattern espelho do `useMcpHandshakeListener` (em features/admin/integrations/),
 * mas escopo MAIS RESTRITO: só escuta o evento cross-feature canonical.
 * Montado no `AppShell` (carrega quando user logado, persiste enquanto navega).
 *
 * Sub-fatia 10.0 PR 3 ContextBlock + Sprint A4 S1 PR 3 cross-feature:
 *   - Admin pausa feature → backend emite WS → este listener invalida
 *     `['customer-context']` → ContextBlock no painel direito de QUALQUER
 *     conversa aberta refetch → exibe regra do silêncio sem refresh manual.
 *
 * O listener completo (com mcp.handshake-completed para list de conectores)
 * continua só em IntegrationsPage — só faz sentido invalidar list de
 * conectores quando admin está visualizando a página de admin.
 */
export function useIntegrationsFeatureToggleInvalidate(): void {
  const qc = useQueryClient();
  const { subscribe } = useWebSocket();

  useEffect(() => {
    const off = subscribe(WS_EVENTS.INTEGRATIONS_FEATURE_TOGGLED, () => {
      void qc.invalidateQueries({ queryKey: ['customer-context'] });
    });
    return () => {
      off();
    };
  }, [qc, subscribe]);
}
